var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 2568"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    d: "M45 24C45 35.598 35.598 45 24 45C12.402 45 3 35.598 3 24C3 12.402 12.402 3 24 3C35.598 3 45 12.402 45 24ZM21.5178 31.5982C21.9156 31.6093 22.317 31.4631 22.6206 31.1595L34.9243 18.8558C35.1586 18.6215 35.1586 18.2416 34.9243 18.0073L33.1211 16.2042C32.8868 15.9699 32.5069 15.9699 32.2726 16.2042L21.5584 26.9184L15.7275 21.0876C15.4932 20.8533 15.1133 20.8533 14.879 21.0876L13.0759 22.8907C12.8416 23.125 12.8416 23.5049 13.0759 23.7392L20.4961 31.1594C20.7791 31.4424 21.147 31.5887 21.5178 31.5982Z",
    fill: "#8AB654"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.b62dc3fcd0e1839f0dd99d0409e28ef0.svg";
export { ForwardRef as ReactComponent };